import React, { useState, useEffect } from 'react';
import {
    Link
} from "react-router-dom";
import CategoryProductList from '../../components/ProductList/category-product-list';
import { useTranslation } from 'react-i18next';
import '../../../i18n';
import { useMsal } from '@azure/msal-react';
import { InteractionStatus } from '@azure/msal-browser';
import useAxios from 'scripts/hooks/useAxios';
import { useGlobalState } from '../../contexts/GlobalStateContext';
import { TableLoader } from '../../components/ContentLoader';
import { alertLoadingError } from '../../components/Confirm';

export default function ProductsCurrent() {
    const { inProgress } = useMsal();
    const { callApi } = useAxios();
    const { t } = useTranslation()
    const { globalState } = useGlobalState();
    const [products, setProducts] = useState(null);

    useEffect(() => {
        if (!products && inProgress === InteractionStatus.None && globalState?.activeUserCompany) {
            callApi({
                method: 'get',
                url: '/api/product/allmodelseries',
                headers: {
                    'x-active-user-company': globalState.activeUserCompany?.contactId,
                },
            }).then((res) => {
                let newProducts = res.data.value.map((o) => ({
                   
                    title: o.ed_id
                }));
                setProducts(newProducts);
            }).catch((err) => {
                alertLoadingError(t);
                console.error(err); // eslint-disable-line no-console
            });
        }
    }, [products, inProgress, callApi, globalState?.activeUserCompany, t]);

    useEffect(() => {
        setProducts(null);
    }, [globalState?.activeUserCompany]);

    return (
        <div className="main-content">

            <div className="content-primary">
                <h1>{t('my-pages.add-products-title')}</h1>
                <p>{t('my-pages.add-products-description')}</p>
                <Link
                    to="/my-pages/products-in-showroom"
                    className="button-secondary"
                >
                    {t('button.products-in-showroom')}
                </Link>
            </div>
            {!products ? (
                <TableLoader />
            ) : (
                <CategoryProductList
                    items={products}
                    toggleShowAddProducts={false}
                />
            )}
        </div>
    );
}
